import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getImportStatusAvatar = value => {
  switch (value) {
    case 'in_progress':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "info",
        hollow: true,
        "data-test-id": "marketing-event-import-status-dot-in-progress"
      });
    case 'complete':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "success",
        "data-test-id": "marketing-event-import-status-dot-complete"
      });
    case 'import_failed':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "error",
        "data-test-id": "marketing-event-import-status-dot-import-failed"
      });
    case 'import_reverted':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "error",
        "data-test-id": "marketing-event-import-status-dot-import-reverted"
      });
    default:
      return undefined;
  }
};
const FormattedMarketingEventImportStatus = ({
  property,
  value,
  objectTypeId
}) => {
  return /*#__PURE__*/_jsxs("span", {
    children: [getImportStatusAvatar(value), getDisplayedValue(property, value, undefined, undefined, objectTypeId)]
  });
};
export default FormattedMarketingEventImportStatus;